import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const AddContributionModal = ({ onClose, onAdd, goal }) => {
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    amount: '',
    contributionDate: new Date()?.toISOString()?.split('T')?.[0],
    notes: ''
  });

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');

    // Validate goal target amount
    if (goal?.targetAmount <= 0) {
      setError('Cannot add contribution: Goal target amount must be greater than zero. Please edit the goal to set a valid target amount.');
      return;
    }

    if (!formData?.amount || parseFloat(formData?.amount) <= 0) {
      setError('Please enter a valid contribution amount');
      return;
    }

    try {
      await onAdd({
        amount: parseFloat(formData?.amount),
        contributionDate: formData?.contributionDate,
        notes: formData?.notes
      });
    } catch (err) {
      setError(err?.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-16">
      <div className="bg-card rounded-lg shadow-elevation-4 w-full max-w-md">
        <div className="flex items-center justify-between p-24 border-b border-border">
          <h2 className="text-xl font-semibold text-card-foreground">Add Contribution</h2>
          <button
            onClick={onClose}
            className="p-8 hover:bg-muted rounded-lg transition-smooth min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-24">
          {error && (
            <div className="mb-16 p-12 bg-destructive/10 border border-destructive rounded-lg">
              <p className="text-sm text-destructive">{error}</p>
            </div>
          )}

          <div className="mb-20">
            <label className="block text-sm font-medium text-foreground mb-8">
              Contribution Amount *
            </label>
            <div className="relative">
              <span className="absolute left-16 top-1/2 -translate-y-1/2 text-muted-foreground">$</span>
              <input
                type="number"
                step="0.01"
                min="0"
                value={formData?.amount}
                onChange={(e) => setFormData({ ...formData, amount: e?.target?.value })}
                className="w-full pl-32 pr-16 py-12 bg-background border border-input rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary min-h-[44px]"
                placeholder="0.00"
                required
              />
            </div>
          </div>

          <div className="mb-20">
            <label className="block text-sm font-medium text-foreground mb-8">
              Date *
            </label>
            <input
              type="date"
              value={formData?.contributionDate}
              onChange={(e) => setFormData({ ...formData, contributionDate: e?.target?.value })}
              className="w-full px-16 py-12 bg-background border border-input rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary min-h-[44px]"
              required
            />
          </div>

          <div className="mb-24">
            <label className="block text-sm font-medium text-foreground mb-8">
              Notes (Optional)
            </label>
            <textarea
              value={formData?.notes}
              onChange={(e) => setFormData({ ...formData, notes: e?.target?.value })}
              className="w-full px-16 py-12 bg-background border border-input rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary min-h-[80px] resize-none"
              placeholder="Add any notes about this contribution..."
              rows={3}
            />
          </div>

          <div className="flex gap-12">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-20 py-12 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-smooth font-medium min-h-[44px]"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-20 py-12 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth font-medium min-h-[44px]"
            >
              Add Contribution
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContributionModal;